import { useCallback, useEffect } from "react";
import styles from "../header/HeaderStyles.module.scss";
import { SearchIcon } from "../../modules/default-svg";
import debounce from "lodash/debounce";

const KanbanSearch = (props) => {

const {
  inputClassNames = "",
  containerClassNames = "",
  isDisabled = false,
  triggerSearch,
  handleChange,
  searchTerm
} = props;
  const triggerSearchDebounced = useCallback(
    debounce((value) => {
      triggerSearch(value);
    }, 500),
    [triggerSearch]
  );

  useEffect(() => {
    return () => {
      triggerSearchDebounced.cancel();
    };
  }, [triggerSearchDebounced]);

  const onChangeHandler = (value) => {
    handleChange(value);
    triggerSearchDebounced(value);
  };

  return (
    <div className={`${styles.searchStylesWrapper} ${containerClassNames}`}>
      <input
        className={`${styles.searchStyles} ${inputClassNames}`}
        type="search"
        placeholder="Search"
        value={searchTerm}
        disabled={isDisabled}
        autoComplete="off"
        onChange={(e) => onChangeHandler(e.target.value)}
      />
      <span className={`${styles.searchIcon} d-inline-flex`}>
        <SearchIcon />
      </span>
    </div>
  );
};

export default KanbanSearch;